(function () {
  'use strict';

  function route(path) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    return root.replace(/\/$/, '') + path;
  }

  function fixContactLinks() {
    Array.prototype.forEach.call(
      document.querySelectorAll('a[href="https://wa.me/"], a[href="https://wa.me"]'),
      function (link) {
        link.href = 'https://wa.me/8615312448658';
        link.setAttribute('aria-label', 'Contact Crystal Wholesale China on WhatsApp');
      }
    );
  }

  function initContactForm() {
    var forms = document.querySelectorAll('form[action*="/contact"]');
    var contactForm = null;

    for (var index = 0; index < forms.length; index += 1) {
      if (forms[index].querySelector('textarea[name="contact[body]"]')) {
        contactForm = forms[index];
        break;
      }
    }

    if (!contactForm) return;

    var email = contactForm.querySelector('input[type="email"]');
    var message = contactForm.querySelector('textarea[name="contact[body]"]');
    var submit = contactForm.querySelector('button[type="submit"], input[type="submit"]');
    if (!email || !message || !submit) return;

    document.documentElement.classList.add('cwc-contact-page');
    document.body.classList.add('cwc-contact-page');

    message.required = true;
    message.minLength = 10;
    email.setAttribute('autocomplete', 'email');
    contactForm.setAttribute('novalidate', '');

    function emailIsValid() {
      return email.value.trim() !== '' && email.validity.valid;
    }

    function messageIsValid() {
      return message.value.trim().length >= 10;
    }

    function setFieldState(field, valid, reveal) {
      field.setAttribute('aria-invalid', reveal && !valid ? 'true' : 'false');
    }

    function updateSubmit() {
      var valid = emailIsValid() && messageIsValid();
      submit.disabled = !valid;
      submit.setAttribute('aria-disabled', valid ? 'false' : 'true');
      return valid;
    }

    email.addEventListener('input', function () {
      setFieldState(email, emailIsValid(), false);
      updateSubmit();
    });
    message.addEventListener('input', function () {
      setFieldState(message, messageIsValid(), false);
      updateSubmit();
    });
    email.addEventListener('blur', function () {
      setFieldState(email, emailIsValid(), true);
      updateSubmit();
    });
    message.addEventListener('blur', function () {
      setFieldState(message, messageIsValid(), true);
      updateSubmit();
    });

    contactForm.addEventListener('submit', function (event) {
      setFieldState(email, emailIsValid(), true);
      setFieldState(message, messageIsValid(), true);
      if (!updateSubmit()) {
        event.preventDefault();
        (emailIsValid() ? message : email).focus();
        return;
      }
      submit.disabled = true;
      submit.setAttribute('aria-disabled', 'true');
      submit.setAttribute('aria-busy', 'true');
      if (submit.tagName === 'BUTTON') submit.textContent = 'Sending\u2026';
    }, true);

    Array.prototype.forEach.call(
      contactForm.querySelectorAll('.success, .form-success, [data-form-status]'),
      function (status) {
        status.setAttribute('role', 'status');
        status.setAttribute('aria-live', 'polite');
      }
    );

    updateSubmit();
  }

  function fixPlaceholderNavigationLinks() {
    Array.prototype.forEach.call(
      document.querySelectorAll('#nav-bar a[href="./"], #nav a[href="./"]'),
      function (link) {
        if (link.textContent.trim() === 'All collections') link.href = route('/collections');
      }
    );
  }

  fixContactLinks();
  initContactForm();
  fixPlaceholderNavigationLinks();
})();
